module.exports = __webpack_public_path__ + "static/media/10926275_878176462232682_1298555271027059032_o.bb776aa2.jpg";